/**
 * Registrant-facing waitlist copy, used verbatim by the waitlist email.
 * The wording is fixed by CHI-5: change it only with the ticket, and never add
 * rejected/denied/refused/failed/not selected language.
 */
export const WAITLIST_REGISTRANT_COPY =
  "We've added you to a waitlist — this event has currently met its capacity, and we'll let you know if a spot opens up.";

export const WAITLISTED_REGISTRATION_STATE = "waitlisted" as const;

/**
 * The under-review state introduced by CHI-3. Compared as a string because the
 * schema enum does not carry it until that ticket lands.
 */
export const PENDING_REVIEW_REGISTRATION_STATE = "pending_review";

export function isWaitlistedRegistration(registrationState: string | null | undefined) {
  return registrationState === WAITLISTED_REGISTRATION_STATE;
}

export function isPendingReviewRegistration(registrationState: string | null | undefined) {
  return registrationState === PENDING_REVIEW_REGISTRATION_STATE;
}

/** Words that must never reach a registrant in UI or email copy. */
export const BANNED_REGISTRANT_COPY_PATTERN = /\b(rejected|denied|refused|failed|not selected)\b/i;
